import React from 'react';

import { CustomReportParamTypes } from '../../shared/customReports/constants';
import ParamSelect from './paramSelect.component';
import ParamInput from './paramInput.component';
import UserRoles from '../../shared/authorization/userRoles';


type CustomReportParameterProps = {
  param: any,
  paramsOptions: any[],
  isLoading: boolean,
  queryParams: any,
  updateValue: () => void,
  archivalFlag: boolean,
  restrictBatchDefaults?: boolean,
  userRole: string,
  editable:boolean
}

export const CustomReportParameter = ({
  param,
  paramsOptions,
  updateValue,
  isLoading,
  queryParams,
  archivalFlag,
  restrictBatchDefaults = false,
  userRole,
  editable,
}: CustomReportParameterProps) => {
  if (param.type === CustomReportParamTypes.validator) {
    return null;
  }

  const key = param.id || param.name;

  const options = paramsOptions && paramsOptions[key]
    ? paramsOptions[key]
    : [];
  const isDisable = () => {
    const labelName = param.mappingName;
    if (archivalFlag && labelName.replace(/ /g, '').toLowerCase().includes('companycode')) {
      return true;
    }
    if (restrictBatchDefaults && userRole === UserRoles.SUPER_USER && !editable) {
      return true;
    }
    if (restrictBatchDefaults && editable) {
      return false;
    }
    if (restrictBatchDefaults) {
      return true;
    }
    return false;
  };

  return (
    <div className="custom-param-selector" key={key}>
      <div className="custom-param-label">{param.mappingName}</div>
      {
        param.type === CustomReportParamTypes.query
          ? <ParamSelect
            name={key}
            value={queryParams[key]}
            options={options}
            onChange={updateValue}
            isLoading={isLoading}
            disable={isDisable()}
          />
          : <ParamInput
            name={key}
            value={queryParams[key]}
            onChange={updateValue}
            isLoading={isLoading}
            archivalFlag={archivalFlag}
          />
      }
    </div>
  );
};
